/** 金额展示：后端 BigDecimal 常以字符串返回，不能直接 toFixed */

export function toAmountNumber(value: unknown, fallback = 0): number {
  if (value == null || value === '') return fallback
  const num = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(num) ? num : fallback
}

export function formatAmount(value: unknown, digits = 2): string {
  if (value == null || value === '') return '—'
  const num = toAmountNumber(value, NaN)
  if (!Number.isFinite(num)) return '—'
  return num.toFixed(digits)
}

/** 账单详情汇率：兼容 { rates: { USD: 7.24 } } 与平铺结构，值统一为 number */
export function normalizeExchangeRates(raw: unknown): Record<string, number> {
  if (!raw || typeof raw !== 'object') return {}
  const source = (raw as { rates?: Record<string, unknown> }).rates ?? raw
  if (!source || typeof source !== 'object') return {}
  const result: Record<string, number> = {}
  for (const [currency, rate] of Object.entries(source as Record<string, unknown>)) {
    const num = toAmountNumber(rate, NaN)
    if (Number.isFinite(num) && num > 0) {
      result[currency] = num
    }
  }
  return result
}
